import { render, staticRenderFns } from "./HolidayList.vue?vue&type=template&id=0995b4b8&"
import script from "./HolidayList.vue?vue&type=script&lang=js&"
export * from "./HolidayList.vue?vue&type=script&lang=js&"
import style0 from "./HolidayList.vue?vue&type=style&index=0&id=0995b4b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports